// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".agent-tile--YFqRF{border:1px solid #f0f0f4;background-color:rgba(0,0,0,0);cursor:pointer}.agent-tile--YFqRF:hover{border-color:#b4bccd}.agent-tile--selected--S6NLJ{border-color:#5645f5;background-color:rgba(86,69,245,.05)}.agent-name--PmJWA{font-size:15px}.agent-id--NBToF{font-size:12px}.agent-check--T5T1f{top:12px;right:16px;font-size:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"agent-tile": "agent-tile--YFqRF",
	"agent-tile--selected": "agent-tile--selected--S6NLJ",
	"agent-name": "agent-name--PmJWA",
	"agent-id": "agent-id--NBToF",
	"agent-check": "agent-check--T5T1f"
};
export default ___CSS_LOADER_EXPORT___;
